import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface AddPatientTabParams {
  patientId: string;
}

interface AddPatientTabResponse {
  patients: { addedAt: string; patientId: string }[];
}

export const useAddPatientTab = () => {
  const queryClient = useQueryClient();

  return useApiMutation<AddPatientTabResponse, AddPatientTabParams>({
    mutationOptions: {
      mutationKey: ["provider", "add-patient"],
      mutationFn: (params) => {
        return axiosInstance.post("/new-api/providers/add-patient-tab", params);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["provider", "patient-tabs"],
        });
      },
    },
  });
};
